import React from 'react';

const FooComponent = (props) => {
  return <div />;
};
export default FooComponent;
